export const DIALOG_TYPES = {
    ALERT: 'alert',
    PROMPT: 'prompt',
    CONFIRM: 'confirm'
}

export default class Dialog
{
    static get TYPE_ALERT() {
        return DIALOG_TYPES.ALERT
    }

    static get TYPE_PROMPT() {
        return DIALOG_TYPES.PROMPT
    }

    static get TYPE_CONFIRM() {
        return DIALOG_TYPES.CONFIRM
    }

    constructor(Vue) {
        this.Vue = Vue
        this.$modal = {}
        this.mounted = false
        this.customComponent = false
    }

    confirm(message = null, options = {}, component = undefined) {
        message && (options.content = message)

        if( options.title === undefined ) {
            options.title = 'Confirmation'
        }

        if( options.content === undefined ) {
            options.content = 'Are you sure you want to execute this operation?'
        }

        return this.open(DIALOG_TYPES.CONFIRM, options, component)
    }

    // prompt(message = null, options = {}, component = undefined) {
    //     message && (options.content = message)
    //     return this.open(DIALOG_TYPES.PROMPT, options, component)
    // }

    alert(message = null, options = {}, component = undefined) {
        message && (options.content = message)

        if( options.title === undefined ) {
            options.title = 'Information'
        }

        if( options.displayCancelButton === undefined ) {
            options.displayCancelButton = false
        }

        if( options.confirmButtonText === undefined ) {
            options.confirmButtonText = 'Continue'
        }

        return this.open(DIALOG_TYPES.ALERT, options, component)
    }

    /////////////////
    open(type, options = {}, component = undefined) {

        this.state = undefined
        this.customComponent = false

        if( component !== undefined ) {
            this.customComponent = component
            this.$target = options
        }

        this.mount(options)

        if( this.customComponent === false ) {
            this.$target = this.$modal
        }

    	return new Promise((resolve, reject) => {

            for( let prop in options ) {
                this.$target[prop] = options[prop]
            }

            this.$modal.$on('confirm', () => {
                this.state = 'ok'

                if( this.$target.close || this.$target.close === undefined ) {
                    this.close()
                } else {
                    resolve(this)
                }
            })

            this.$modal.$on('close', () => {
                this.state = 'cancel'

                this.close()
                reject()
            })

            this.$modal.$on('close-complete', () => {
                this.destroy()

                if( this.state === 'ok' ) {
                    resolve(this)
                }
            })

            this.$target.show = true
    	})
    }

    close() {
        this.$target.show = false
    }

    destroy() {
        if (this.mounted !== true) {
            return
        }

        let elem = this.$modal.$el
        this.$modal.$off()

        Vue.nextTick(() => {
            if( this.$modal._isDestroyed === false ) {
                this.$modal.$destroy()
            }
        })

        if( this.customComponent === false ) {
            elem.remove()
        }

        this.mounted = false
    }

    mount(options) {
        if (this.mounted === true) {
            return
        }

        if( this.customComponent !== false ) {
            this.$modal = this.customComponent
            return
        } else {
            this.$modal = (() => {
                let node = document.createElement('div')
                document.querySelector('body').appendChild(node)

                let ModalConstructor = Vue.component('oc-modal')

                let modalVM = new ModalConstructor({
                    propsData: Object.assign({
                        show: true
                    }, options)
                })

                return modalVM.$mount(node)
            })()
        }

        this.mounted = true
    }
}
